import React from "react";

const WeatherDetail = ({ icon, value, label }) => {
  return (
    <div className="weather-detail-item">
      <span className="detail-icon" aria-hidden="true">{icon}</span>
      <span className="detail-value">{value}</span>
      <span className="detail-label">{label}</span>
    </div>
  );
};

export default WeatherDetail;
